import assets from 'modules/assets';
import useTitle from 'modules/useTitle';
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';

export default function Withdraw() {
  useTitle('提现详情');

  return (
    <div className={styles.container}>
      <img src={assets.invitationGift.success} className={styles.icon} />
      <div className={styles.title}>提现申请已提交</div>
      <div className={styles.hint}>预计3天内到账</div>
      <Link to="/invitation_gift">
        <div className={styles.button}>返回首页</div>
      </Link>
    </div>
  );
}
